import { GalleryItem, IProduct } from '@topshots/core-models';
import { useAppDispatch } from '../app/hooks';
import { Button } from '../button/button';
import { ButtonTier } from '../button/button.types';
import { close } from '../modal/modalSlice';
import styles from './start-montage-modal.module.css';
import { start } from './montage.slice';
import { MontageGrid } from './montage-grid';

export const StartMontageModal = ({
  product,
  images,
  albumId,
  eventId,
}: {
  product: IProduct;
  images: GalleryItem[];
  albumId: string;
  eventId: string;
}) => {
  const dispatch = useAppDispatch();
  return (
    <div>
      <p>
        {product.name} requires {product.imagesRequired} images.
      </p>
      <MontageGrid items={images} requiredItems={product.imagesRequired} />
      <div className={styles.buttons}>
        <Button
          tier={ButtonTier.Tertiary}
          className={styles.cancelButton}
          onClick={() => {
            dispatch(close());
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            dispatch(
              start({
                product: product,
                albumId: albumId,
                eventId: eventId,
                item: images[0],
              })
            );
            dispatch(close());
          }}
          className={styles.addButton}
        >
          Start building {product.name}
        </Button>
      </div>
    </div>
  );
};
